var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IconName } from "@eightfold.ai/octuple";
import { ButtonVariant, IconButton } from "../Button/Button";
import { useNavigate } from "react-router-dom";
import DeleteReportIcon from "../DeleteReportIcon/DeleteReportIcon";
import Dialog from "../Dialog";
import styles from "./cohort.module.scss";
import { getRoute } from "../../routes/getAllRoutes";
import { useState } from "react";
import { deleteCohortReportMutation } from "../../store/api/core";
import { useReportData } from "../../providers/ReportDataProvider";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
var EditReportButton = function (_a) {
    var reportId = _a.reportId;
    var setReportData = useReportData().setReportData;
    var navigate = useNavigate();
    return (_jsx(IconButton, __assign({ iconPath: IconName.mdiCog, variant: ButtonVariant.Neutral }, getAutomationTag(TestTag.DropdownOptionEdit), { onClick: function () {
            setReportData({});
            setTimeout(function () {
                navigate(getRoute("EditReport").replace(":reportId", reportId));
            }, 0);
        } })));
};
var DeleteReportButton = function (_a) {
    var reportId = _a.reportId;
    var navigate = useNavigate();
    var _b = useState(false), deleteDialogVisible = _b[0], setDeleteDialogVisible = _b[1];
    var deleteReport = deleteCohortReportMutation({
        substitutions: { reportId: reportId },
        invalidates: [{ queryKey: ["{dashboard}/{ClientId}/cohort-report"] }],
    });
    var handleConfirmDelete = function () {
        deleteReport.mutate({}, {
            onSuccess: function () {
                setDeleteDialogVisible(false);
                navigate(getRoute("CohortInsightsV2"));
            },
            onError: function () {
                setDeleteDialogVisible(false);
                // Optionally show error feedback
            },
        });
    };
    var deleteDialogProps = {
        header: "Are you sure you want to delete this report?",
        body: (_jsx("span", __assign({ className: styles.dialogBodyWarning }, { children: "This action cannot be undone." }))),
        buttons: {
            okButtonProps: {
                text: "Confirm and Delete",
                onClick: handleConfirmDelete,
                loading: deleteReport.isPending,
            },
            cancelButtonProps: {
                text: "Cancel",
                onClick: function () { return setDeleteDialogVisible(false); },
            },
        },
    };
    var onDelete = function () { return setDeleteDialogVisible(true); };
    return (_jsxs(_Fragment, { children: [_jsx(DeleteReportIcon, { reportId: reportId, onClick: onDelete, className: styles.deleteIconContainer }), deleteDialogVisible && (_jsx(Dialog, __assign({}, deleteDialogProps, { visible: deleteDialogVisible, onClose: function () { return setDeleteDialogVisible(false); } })))] }));
};
export var MutateReportButtons = function (_a) {
    var reportId = _a.reportId;
    return (_jsxs(_Fragment, { children: [_jsx(EditReportButton, { reportId: reportId }), _jsx(DeleteReportButton, { reportId: reportId })] }));
};
